import React, { useState, useEffect } from "react";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
import axios from "axios";

const HomeFaqs = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/faqs/get-all-faqs`
      );
      // Get only first 5 valid FAQs excluding return policy
      const validFaqs = (response.data.data || []).filter(
        (faq) =>
          !faq.question?.toLowerCase().includes("return policy") &&
          !faq.answer?.toLowerCase().includes("return policy")
      );
      setFaqs(validFaqs.slice(0, 5));
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="bg-white py-3 px-4 md:px-8 lg:px-12 mb-8">
      <div className="">
        {/* Header */}
        <div className="text-center mb-12">
          <h2
            className="font-heading text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-primaryTextColor to-primaryBtnHoverColor bg-clip-text"
            style={{
              backgroundImage: "linear-gradient(to right, #080808, #CD1B1B)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <p className="text-lg md:text-xl" style={{ color: "#1E1E1E" }}>
            Find answers to common questions
          </p>
        </div>

        {/* FAQs List */}
        <div className="space-y-4">
          {loading ? (
            <>
              {[1, 2, 3, 4, 5].map((i) => (
                <div
                  key={i}
                  className="h-20 rounded-2xl animate-pulse"
                  style={{ backgroundColor: "#e5e7eb" }}
                />
              ))}
            </>
          ) : faqs.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-lg" style={{ color: "#6b7280" }}>
                No FAQs available at the moment
              </p>
            </div>
          ) : (
            faqs.map((faq, index) => (
              <div key={faq._id} className="group relative">
                <div
                  className={`relative rounded-2xl p-1 overflow-hidden transition-all duration-500 ${
                    activeIndex === index ? "bg-opacity-70" : "bg-opacity-50"
                  }`}
                  style={
                    activeIndex === index
                      ? {
                          backgroundImage:
                            "linear-gradient(to bottom right, #050733, #080808)",
                        }
                      : {
                          backgroundImage:
                            "linear-gradient(to bottom right, #f3f4f6, #e5e7eb)",
                        }
                  }
                >
                  {/* Background Pattern */}
                  <div className="absolute inset-0 opacity-10">
                    <div
                      className="absolute inset-0 bg-repeat"
                      style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M0 0h40v40H0V0zm20 20h20v20H20V20zm0-20h20v20H20V0z'/%3E%3C/g%3E%3C/svg%3E")`,
                      }}
                    ></div>
                  </div>

                  {/* Glow Effect */}
                  {activeIndex === index && (
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-red-600/20 rounded-3xl blur-lg opacity-25 group-hover:opacity-50 transition duration-300"></div>
                  )}

                  <div className="relative bg-white bg-opacity-95 backdrop-blur-sm rounded-2xl overflow-hidden shadow-lg">
                    <button
                      onClick={() => toggleFaq(index)}
                      className="w-full px-6 py-5 text-left flex justify-between items-center transition-all duration-500"
                      style={{
                        backgroundColor:
                          activeIndex === index
                            ? "#050733"
                            : "rgba(255, 255, 255, 0.8)",
                        color: activeIndex === index ? "white" : "#080808",
                      }}
                    >
                      <span className="font-bold text-lg md:text-xl pr-4">
                        {faq.question}
                      </span>
                      {activeIndex === index ? (
                        <FaCircleMinus
                          size={26}
                          className="transition-transform duration-500 rotate-0 flex-shrink-0"
                          style={{ color: "white" }}
                        />
                      ) : (
                        <FaCirclePlus
                          size={26}
                          className="transition-transform duration-500 rotate-0 hover:rotate-90 flex-shrink-0"
                          style={{ color: "#CD1B1B" }}
                        />
                      )}
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-700 ease-in-out ${
                        activeIndex === index
                          ? "max-h-96 opacity-100"
                          : "max-h-0 opacity-0"
                      }`}
                      style={{
                        transitionProperty: "max-height, opacity",
                      }}
                    >
                      <div
                        className="px-6 py-5 border-t text-lg leading-relaxed bg-white bg-opacity-90"
                        style={{ color: "#1E1E1E" }}
                      >
                        {faq.answer}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeFaqs;
